<template>
  <section>
    <div class="row">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ul class="breadcrumb">
            <li class="breadcrumb-item h3 font-weight-bold mb-0">
              <router-link
                v-bind:to="{
                  name: 'program-study/index',
                  params: { type: course.department.courseCategoryID },
                }"
              >
                Prodi Kuliah {{ course.department.courseCategory.name }}
              </router-link>
            </li>
            <li
              class="breadcrumb-item active font-weight-medium"
              aria-current="page"
            >
              Edit Prodi
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card shadow-sm mb-4 border-0">
          <div class="card-header background-primary">
            <div class="row">
              <div class="col">
                <span class="h4 font-weight-medium text-white mb-0">
                  Edit Prodi: {{ course.name }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form v-on:submit.prevent="save">
              <div class="form-group">
                <label class="font-weight-medium">Gambar Header</label>
                <input
                  id="image"
                  type="file"
                  class="form-control"
                  v-on:change="preview"
                  placeholder="Choose File"
                  accept="image/*"
                />
                <label for="image" class="form-control form-control-sm">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm font-weight-bold"
                  >
                    Choose File
                  </button>
                </label>
                <img v-bind:src="imagePreview" class="img-fluid mt-2 w-100" />
              </div>
              <div class="form-group">
                <label class="font-weight-medium required">Nama Rumpun</label>
                <multiselect
                  v-model="department"
                  v-on:select="
                    (department) => (form.departmentID = department.id)
                  "
                  v-bind:options="departments"
                  v-bind:allow-empty="false"
                  tag-placeholder=""
                  select-label=""
                  label="name"
                  track-by="id"
                  placeholder="Nama Rumpun"
                  class="form-control form-control-sm"
                  required
                >
                </multiselect>
              </div>
              <div class="form-group">
                <label class="font-weight-medium required">Nama Prodi</label>
                <input
                  v-model="form.name"
                  class="form-control form-control-sm"
                  placeholder="Nama Prodi"
                  required
                />
              </div>
              <div class="form-group">
                <label class="font-weight-medium">Gambaran Umum</label>
                <tinymce
                  id="text-editor-description"
                  v-model="form.description"
                  v-bind:other_options="tinyMCEOptions"
                ></tinymce>
              </div>
              <div class="form-group">
                <label class="font-weight-medium">Prospek Kerja</label>
                <tinymce
                  id="text-editor-prospect"
                  v-model="form.prospect"
                  v-bind:other_options="tinyMCEOptions"
                ></tinymce>
              </div>
              <div class="form-group">
                <label class="font-weight-medium"
                  >Mata Kuliah Yang Dipelajari</label
                >
                <tinymce
                  id="text-editor-subject"
                  v-model="form.subject"
                  v-bind:other_options="tinyMCEOptions"
                ></tinymce>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4 pr-1">
                      <label class="font-weight-medium required text-muted"
                        >Nama Universitas</label
                      >
                    </div>
                    <div class="col-4 px-1">
                      <label class="font-weight-medium required text-muted"
                        >Nama Jurusan</label
                      >
                    </div>
                    <div class="col-2 px-1">
                      <label class="font-weight-medium text-muted">NBA</label>
                    </div>
                    <div class="col pl-1">
                      <label class="font-weight-medium text-muted"
                        >Akreditasi</label
                      >
                    </div>
                    <div class="col px-1">
                      <label class="font-weight-medium text-muted"
                        >DT 2022</label
                      >
                    </div>
                    <div class="col px-1">
                      <label class="font-weight-medium text-muted"
                        >Keketatan 2021</label
                      >
                    </div>
                  </div>
                  <div
                    class="row mb-1"
                    v-for="(universityCourse, index) in form.universityCourses"
                  >
                    <div class="col-4 pr-1">
                      <div class="form-group">
                        <multiselect
                          v-model="universityCourse.university"
                          v-on:select="
                            (university) =>
                              (universityCourse.universityID = university.id)
                          "
                          v-bind:options="universities"
                          v-bind:allow-empty="false"
                          tag-placeholder=""
                          select-label=""
                          label="name"
                          track-by="id"
                          placeholder="Nama Universitas"
                          class="form-control form-control-sm"
                          required
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-4 px-1">
                      <div class="form-group">
                        <input
                          v-model="universityCourse.name"
                          class="form-control form-control-sm"
                          placeholder="Nama Jurusan"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-2 px-1">
                      <div class="form-group">
                        <div class="input-group input-group-sm mb-3">
                          <input
                            v-model="universityCourse.nba"
                            type="number"
                            min="0"
                            max="1000"
                            step="0.01"
                            class="form-control form-control-sm"
                            placeholder="50.87"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text"
                              ><i class="fa fa-percent"></i
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col px-1">
                      <div class="form-group">
                        <input
                          v-model="universityCourse.accreditation"
                          class="form-control form-control-sm"
                          placeholder="A"
                          maxlength="10"
                        />
                      </div>
                    </div>
                    <div class="col px-1">
                      <div class="form-group">
                        <input
                          v-model="universityCourse.graduates"
                          class="form-control form-control-sm"
                          placeholder="10"
                          maxlength="4"
                        />
                      </div>
                    </div>
                    <div class="col px-1">
                      <div class="form-group">
                        <input
                          v-model="universityCourse.keketatan"
                          class="form-control form-control-sm"
                          placeholder="10"
                          maxlength="4"
                        />
                      </div>
                    </div>
                    <div class="col-auto pl-1 text-center">
                      <a href="#" v-on:click.prevent="remove(index)">
                        <i class="fa fa-times text-danger"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-4">
                  <button
                    class="btn btn-link btn-sm px-0"
                    type="button"
                    v-on:click="add()"
                  >
                    Tambah Data +
                  </button>
                </div>
              </div>
              <div class="pt-3 text-center">
                <button type="submit" class="btn btn-danger btn-sm px-5">
                  Save
                </button>
                <router-link
                  v-bind:to="{
                    name: 'program-study/index',
                    params: { type: course.department.courseCategoryID },
                  }"
                  exact
                  class="btn btn-outline-danger btn-sm px-5 ml-3"
                >
                  Cancel
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import tinymce from "vue-tinymce-editor";
import Multiselect from "vue-multiselect";
import { tinyMCEOptions } from "@/params.js";

export default {
  name: "ProgramStudyEdit",
  components: {
    Multiselect,
    tinymce,
  },
  data() {
    return {
      form: {
        name: "",
        departmentID: "",
        general: "",
        prospect: "",
        subject: "",
        image: "",
        universityCourses: [],
      },
      course: { department: { courseCategory: {} } },
      departments: [],
      universities: [],
      department: null,
      imagePreview: "",
      tinyMCEOptions: tinyMCEOptions,
    };
  },
  methods: {
    save() {
      var formData = new FormData();
      for (let attribute in this.form) {
        if (Array.isArray(this.form[attribute])) {
          for (let i = 0; i < this.form[attribute].length; i++) {
            for (let additional in this.form[attribute][i]) {
              if (this.form[attribute][i][additional] !== null) {
                formData.set(
                  attribute + "[" + i + "][" + additional + "]",
                  this.form[attribute][i][additional]
                );
              }
            }
          }
        } else {
          if (this.form[attribute] !== null) {
            formData.set(attribute, this.form[attribute]);
          }
        }
      }
      this.axios
        .post(
          process.env.API_URL + "/course/update/" + this.course.id,
          formData
        )
        .then((response) => {
          if (response.data.status) {
            this.$toastr("success", response.data.message, "Success");
            this.$router.push({
              name: "program-study/view",
              params: {
                type: this.course.department.courseCategoryID,
                id: this.course.id,
              },
            });
          } else {
            this.$toastr(
              "warning",
              response.data.errors[Object.keys(response.data.errors)[0]][0],
              "Warning"
            );
          }
        });
    },
    preview(event) {
      var input = event.currentTarget;
      if (input.files && input.files[0]) {
        this.form.image = input.files[0];
        var reader = new FileReader();
        reader.onload = function (event) {
          this.imagePreview = event.target.result;
        }.bind(this);
        reader.readAsDataURL(input.files[0]);
      }
    },
    add() {
      this.form.universityCourses.push({
        name: "",
        universityID: "",
        nba: "",
        accreditation: "",
        graduates: "",
        keketatan: "",
        university: null,
      });
    },
    remove(index) {
      var universityCourse = this.form.universityCourses[index];
      if (universityCourse.id) {
        if (
          confirm(
            "Hapus jurusan universitas? Jurusan tidak dapat dikembalikan."
          )
        ) {
          this.axios
            .post(
              process.env.API_URL +
                "/university-course/delete/" +
                universityCourse.id
            )
            .then((response) => {
              if (response.data.status) {
                this.$toastr("success", response.data.message, "Success");
                this.form.universityCourses.splice(index, 1);
              } else {
                this.$toastr(
                  "warning",
                  response.data.errors[Object.keys(response.data.errors)[0]][0],
                  "Warning"
                );
              }
            });
        }
      } else {
        this.form.universityCourses.splice(index, 1);
      }
    },
    overrideTinyMCEOptions() {
      this.tinyMCEOptions = Object.assign({}, this.tinyMCEOptions, {
        file_picker_callback: function (callback) {
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.style.visibility = "hidden";
          input.style.position = "absolute";

          input.onchange = function () {
            var file = input.files[0];
            if (file) {
              let formData = new FormData();
              formData.set("image", file);
              this.axios
                .post(process.env.API_URL + "/solution/uploadImage", formData)
                .then((response) => {
                  if (response.data.status) {
                    callback(response.data.location, { alt: file.name });
                  }
                });
            }
          }.bind(this);
          input.click();
        }.bind(this),
      });
    },
  },
  created() {
    this.axios
      .all([
        this.axios.get(
          process.env.API_URL + "/course/" + this.$route.params.id
        ),
        this.axios.get(process.env.API_URL + "/department", {
          params: { courseCategoryID: this.$route.params.type },
        }),
        this.axios.get(process.env.API_URL + "/university"),
      ])
      .then(
        this.axios.spread(
          function (responseCourse, responseDepartment, responseUniversity) {
            this.course = responseCourse.data.data;
            if (
              this.course.department.courseCategoryID !==
              parseInt(this.$route.params.type)
            ) {
              this.$router.replace({
                name: "error",
                params: { code: 404, message: "Program Study not found" },
              });
            }
            this.departments = responseDepartment.data.data;
            this.universities = responseUniversity.data.data;

            this.form = this.course;
            this.form.image = "";
            this.department = this.course.department;
            if (this.course.image) {
              this.imagePreview = this.course.imageUrl;
            }

            document.title =
              "Edit Prodi " + this.course.name + " - " + process.env.APP_NAME;
          }.bind(this)
        )
      );
    this.overrideTinyMCEOptions();
  },
};
</script>

<style scoped>
img:not([src]),
img[src=""] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/program-study/Edit.vue